import BaseRequestService from "./base-request-service";

class cart extends BaseRequestService {
    getCart = query => this.getRequest('api/cart/guest', query)
    checkout = query => this.postRequest('api/checkout/guest', query)
    download = query => this.postRequest('api/checkout/guest/download', query)
    donate = query => this.postRequest('api/checkout/guest/donate', query)
}

export default new cart();